export default {
  popularPickCard: {
    teamGlow: 'dt.quickPicks.popularPickCard.teamGlow',
  },
  components: {
    slip: {
      container: 'dt.quickPicks.components.slip.container',
      components: {
        slipProp: {
          container: 'dt.quickPicks.components.slip.components.slipProp.container',
          playerName: 'dt.quickPicks.components.slip.components.slipProp.playerName',
          direction: 'dt.quickPicks.components.slip.components.slipProp.direction',
        },
      },
    },
    standingsBanner: {
      matched: {
        container: 'dt.quickPicks.components.standingsBanner.matched.container',
        title: 'dt.quickPicks.components.standingsBanner.matched.title',
      },
      voidedUnmatched: {
        container: 'dt.quickPicks.components.standingsBanner.voidedUnmatched.container',
        title: 'dt.quickPicks.components.standingsBanner.voidedUnmatched.title',
      },
    },
    board: {
      picksPanel: {
        viewEntry: 'dt.quickPicks.components.board.picksPanel.viewEntry',
        addAtLeastAmountOfPicks:
          'dt.quickPicks.components.board.picksPanel.addAtLeastAmountOfPicks',
      },
      samePlayerSheet: {
        container: 'dt.quickPicks.components.board.samePlayerSheet.container',
        confirmButton: 'dt.quickPicks.components.board.samePlayerSheet.confirmButton',
        optionExisting: 'dt.quickPicks.components.board.samePlayerSheet.optionExisting',
        optionNew: 'dt.quickPicks.components.board.samePlayerSheet.optionNew',
      },
      picksDrawer: {
        entrySubmitted: {
          container: 'dt.quickPicks.components.board.picksDrawer.entrySubmitted.container',
          picksHeading: 'dt.quickPicks.components.board.picksDrawer.entrySubmitted.picksHeading',
          picksReuseButton:
            'dt.quickPicks.components.board.picksDrawer.entrySubmitted.picksReuseButton',
          closeButton: 'dt.quickPicks.components.board.picksDrawer.entrySubmitted.closeButton',
          pickContainer: 'dt.quickPicks.components.board.picksDrawer.entrySubmitted.pickContainer',
          line: 'dt.quickPicks.components.board.picksDrawer.entrySubmitted.line',
          lineDirectionOver:
            'dt.quickPicks.components.board.picksDrawer.entrySubmitted.lineDirectionOver',
          lineDirectionUnder:
            'dt.quickPicks.components.board.picksDrawer.entrySubmitted.lineDirectionUnder',
        },
        submitButton: 'dt.quickPicks.components.board.picksDrawer.submitButton',
        footNoteRulesLink: 'dt.quickPicks.components.board.picksDrawer.footNoteRulesLink',
        boostsAvailable: 'dt.quickPicks.components.board.picksDrawer.boostsAvailable',
        winMultiplier: 'dt.quickPicks.components.board.picksDrawer.winMultiplier',
        winMultiplierInfoTooltip:
          'dt.quickPicks.components.board.picksDrawer.winMultiplierInfoTooltip',
        winMultiplierInfoTooltipIcon:
          'dt.quickPicks.components.board.picksDrawer.winMultiplierInfoTooltipIcon',
        entryFeeOption: 'dt.quickPicks.components.board.picksDrawer.entryFeeOption',
        entryAmountInput: 'dt.quickPicks.components.board.picksDrawer.entryAmountInput',
        entryAmountBanner: 'dt.quickPicks.components.board.picksDrawer.entryAmountBanner',
        promotionsButton: 'dt.quickPicks.components.board.picksDrawer.promotionsButton',
        removePromotionButton: 'dt.quickPicks.components.board.picksDrawer.removePromotionButton',
        payWithButton: 'dt.quickPicks.components.board.picksDrawer.payWithButton',
        payWithSheet: {
          container: 'dt.quickPicks.components.board.picksDrawer.payWithSheet.container',
          confirmButton: 'dt.quickPicks.components.board.picksDrawer.payWithSheet.confirmButton',
        },
        promotionsSheet: {
          container: 'dt.quickPicks.components.board.picksDrawer.promotionsSheet.container',
        },
        errorMessage: 'dt.quickPicks.components.board.picksDrawer.errorMessage',
        container: 'dt.quickPicks.components.board.picksDrawer.container',
        title: 'dt.quickPicks.components.board.picksDrawer.title',
        closeButton: 'dt.quickPicks.components.board.picksDrawer.closeButton',

        maxPayoutOption: 'dt.quickPicks.components.board.picksDrawer.maxPayoutOption',
        protectedPayoutOption: 'dt.quickPicks.components.board.picksDrawer.protectedPayoutOption',
        pick: {
          container: 'dt.quickPicks.components.board.picksDrawer.pick.container',
          name: 'dt.quickPicks.components.board.picksDrawer.pick.name',
          overButton: 'dt.quickPicks.components.board.picksDrawer.pick.overButton',
          underButton: 'dt.quickPicks.components.board.picksDrawer.pick.underButton',
          removeButton: 'dt.quickPicks.components.board.picksDrawer.pick.removeButton',
        },
      },
    },
  },
  detail: {
    general: {
      main: 'dt.quickPicks.detail.general.main',
      filterButton: 'dt.quickPicks.detail.general.filterButton',
      emptyState: 'dt.quickPicks.detail.general.emptyState',
      searchFilterInputField: 'dt.quickPicks.detail.general.searchFilterInputField',
      emptyStateQuickPicks: 'dt.quickPicks.detail.general.emptyStateQuickPicks',
      iconInfoButton: 'dt.quickPicks.detail.iconInfoButton',
    },
    entries: {
      main: 'dt.quickPicks.detail.entries.main',
    },
    prizePayout: {
      main: 'dt.quickPicks.detail.prizePayout.main',
    },
    description: {
      main: 'dt.quickPicks.detail.description.main',
    },
    rules: {
      main: 'dt.quickPicks.detail.rules.main',
    },
    entrants: {
      main: 'dt.quickPicks.detail.entrants.main',
    },
  },
  tutorial: {
    tutorialModal: 'dt.quickPicks.tutorial.tutorialModal',
    closeButton: 'dt.quickPicks.tutorial.closeButton',
    nextButton: 'dt.quickPicks.tutorial.nextButton',
    placeholderIndicator: 'dt.quickPicks.tutorial.placeholderIndicator',
  },
  playerCell: {
    playerCell: 'dt.quickPicks.playerCell.playerCell',
    playerName: 'dt.quickPicks.playerCell.playerName',
    passYdsNumber: 'dt.quickPicks.playerCell.passYdsNumber',
    metaData: 'dt.quickPicks.playerCell.metaData',
    playerPosition: 'dt.quickPicks.playerCell.playerPosition',
    playerYards: 'dt.quickPicks.playerCell.playerYards',
    overButton: 'dt.quickPicks.playerCell.overButton',
    underButton: 'dt.quickPicks.playerCell.underButton',
  },
  search: {
    inputField: 'dt.quickPicks.search.inputField',
    boardSearchCloseButton: 'dt.quickPicks.search.boardSearchCloseButton',
    searchResultRow: 'dt.quickPicks.search.searchResultRow',
  },
  layout: {
    myEntriesLink: 'dt.quickPicks.layout.myEntriesLink',
  },
};
